import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../../assets/css/Service.css";
import ServiceOne from "../../assets/image/Service/service-1.jpg";
import ServiceTwo from "../../assets/image/Service/service-2.jpg";
import ServiceThree from "../../assets/image/Service/service-3.jpg";
import ServiceFour from "../../assets/image/Service/service-4.jpg";
import ServiceFive from "../../assets/image/Service/service-5.jpg";
import ServiceSix from "../../assets/image/Service/service-6.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { FaCaretRight, FaCaretLeft } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import "swiper/css";
import "swiper/css/navigation";
import image from "../../assets/image/Portfolio/portfolio-bg.png";
import service1 from "../../assets/image/Service/service1.jpg";
import IconOne from "../../assets/image/Service/serviceIcon-1.gif";
import IconTwo from "../../assets/image/Service/serviceicon-2.gif";
import IconThree from "../../assets/image/Service/serviceicon-3.gif";
import IconFour from "../../assets/image/Service/serviceicon-4.gif";
import Card_1 from "../../assets/image/Service/servicecard-1.jpg";
import Card_2 from "../../assets/image/Service/servicecard-2.jpg";
import Card_3 from "../../assets/image/Service/servicecard-3.jpg";
import Card_4 from "../../assets/image/Service/servicecard-4.jpg";
import Card_5 from "../../assets/image/Service/servicecard-5.jpg";
import Card_6 from "../../assets/image/Service/servicecard-6.jpg";
import Card_7 from "../../assets/image/Service/servicecard-7.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../../components/Footer/Footer.js";
import slider_1 from "../../assets/image/Service/slider-1.jpg";
import slider_2 from "../../assets/image/Service/slider-2.jpg";
import slider_3 from "../../assets/image/Service/slider-3.jpg";
import slider_4 from "../../assets/image/Service/slider-4.jpg";
import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";

const Service = () => {
  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [active, setActive] = useState(1);
  // const [activeCard, setActiveCard] = useState(1);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [meta, setMeta] = useState({});

  useEffect(() => {
    // Directly access about_page from data
    const ServiceMeta = data[0]?.services_page;

    // Set meta state if about Meta exists
    if (ServiceMeta) {
      setMeta(ServiceMeta);
    }
  }, []);

  // Service
  const services = [
    {
      id: 1,
      title: "Software Development",
      desc: "We develop mobile, desktop and web games with a completely functional final product.",
      image: ServiceOne,
    },
    {
      id: 2,
      title: "AI Development",
      desc: "Our artists can make 2D and 3D illustrations, character design, concept art...",
      image: ServiceTwo,
    },
    {
      id: 3,
      title: "Game Development",
      desc: "We create detailed 3D models for characters, assets and environments.",
      image: ServiceThree,
    },
    {
      id: 4,
      title: "Casino & Sportsbook API",
      desc: "From concept to levels, we design games for engagement and flow.",
      image: ServiceFour,
    },
    {
      id: 5,
      title: "AR/VR Development",
      desc: "Our team provides strong visual direction for games of any genre.",
      image: ServiceFive,
    },
    {
      id: 6,
      title: "Website Development",
      desc: "Our team provides strong visual direction for games of any genre.",
      image: ServiceSix,
    },
  ];

  // Slider
  const slides = [
    {
      title: "Mobile Game Development",
      text: "Create engaging mobile games for iOS and Android with stunning graphics.",
      img: slider_1,
    },
    {
      title: "PC & Console Games",
      text: "Develop high-end PC and console games with cutting-edge graphics, immersive storylines, and advanced gameplay systems.",
      img: slider_2,
    },
    {
      title: "Multiplayer Games",
      text: "Build engaging multiplayer experiences with real-time gameplay, social features, and competitive elements.",
      img: slider_3,
    },
    {
      title: "Game Monetization",
      text: "Implement monetization strategies to increase revenue.",
      img: slider_4,
    },
    {
      title: "VR/AR Gaming",
      text: "Immerse players in virtual and augmented reality experiences with next-generation gaming technology.",
      img: slider_1,
    },
    {
      title: "Game Art & Design",
      text: "Professional game art services including character design, environment art, and UI/UX for gaming interfaces.",
      img: slider_2,
    },
    {
      title: "Game Testing & QA",
      text: "Comprehensive testing services to ensure your game is bug-free, balanced, and provides the best user experience.",
      img: slider_3,
    },
  ];

  // Additional Service
  const Additionalservice = [
    {
      icon: IconOne,
      title: "App Development",
      image: slider_1,
      desc: "High-performance native and hybrid mobile applications.",
      items: ["Native Apps", "Hybrid Apps", "Cross-Platform", "UI/UX Design"],
    },
    {
      icon: IconTwo,
      title: "Digital Marketing",
      image: slider_2,
      desc: "Strategic digital marketing to build your brand and drive growth.",
      items: ["SEO", "Social Media", "Content Marketing", "PPC Campaigns"],
    },
    {
      icon: IconThree,
      title: "DevOps Solutions",
      image: slider_3,
      desc: "Scalable infrastructure and optimized performance solutions.",
      items: ["CI/CD", "Cloud Services", "Automation", "Monitoring"],
    },
    {
      icon: IconFour,
      title: "IT Support & Solutions",
      image: slider_4,
      desc: "Comprehensive IT support for smooth and secure operations.",
      items: ["24/7 Support", "Security", "Maintenance", "Consulting"],
    },
  ];

  const cardRefs = useRef([]);
  const [visibleCards, setVisibleCards] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = cardRefs.current.indexOf(entry.target);
            if (index !== -1 && !visibleCards.includes(index)) {
              setTimeout(() => {
                setVisibleCards((prev) => [...prev, index]);
              }, index * 200);
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    const currentRefs = cardRefs.current;
    currentRefs.forEach((ref) => ref && observer.observe(ref));

    return () => {
      currentRefs.forEach((ref) => ref && observer.unobserve(ref));
    };
  }, [visibleCards]);

  // Cards
  const games = [
    {
      title: "Ludo Game",
      category: "PLAY",
      categoryColor: "action",
      image: Card_1,
    },
    {
      title: "Rummy Game",
      category: "PLAY",
      categoryColor: "adventure",
      image: Card_2,
    },
    {
      title: "Chess Game",
      category: "PLAY",
      categoryColor: "action",
      image: Card_5,
    },
    {
      title: "Carom Game",
      category: "PLAY",
      categoryColor: "adventure",
      image: Card_4,
    },
    {
      title: "Fantasy Sports",
      category: "PLAY",
      categoryColor: "action",
      image: Card_3,
    },
    {
      title: "E-Commerce Website",
      category: "SHOW",
      categoryColor: "action",
      image: Card_6,
    },
    {
      title: "Tours and Travel Website",
      category: "SHOW",
      categoryColor: "adventure",
      image: Card_7,
    },
  ];

  const sliderRef = useRef(null);

  const trainers = [
    {
      id: 1,
      name: "Software Development",
      desc: "We develop mobile, desktop and web games with a completely functional final product.",
      image: ServiceOne,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    },
    {
      id: 2,
      name: "AI Development",
      desc: "Our artists can make 2D and 3D illustrations, character design, concept art...",
      image: ServiceTwo,
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    },
    {
      id: 3,
      name: "Game Development",
      desc: "We create detailed 3D models for characters, assets and environments.",
      image: ServiceThree,
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    },
    {
      id: 4,
      name: "Casino & Sportsbook API",
      desc: "We create detailed 3D models for characters, assets and environments.",
      image: ServiceFour,
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
    },
    {
      id: 5,
      name: "Mobile App Development",
      desc: "We create detailed 3D models for characters, assets and environments.",
      image: ServiceFive,
      gradient: "linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)",
    },
    {
      id: 6,
      name: "Web Development",
      desc: "We create detailed 3D models for characters, assets and environments.",
      image: ServiceSix,
      gradient: "linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const initAOS = () => {
      const cards = document.querySelectorAll(".trainer-card");
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("aos-animate");
            }
          });
        },
        { threshold: 0.2 }
      );

      cards.forEach((card) => observer.observe(card));
    };

    initAOS();
  }, []);

  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);

  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const form = useRef();

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc",
        "template_evcmg1l",
        form.current,
        "EscxBRJBS9wDUay2E"
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <div style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>{meta?.title || "Service - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Our curriculum is updated with the latest industry trends and tools. With flexible learning options and dedicated support, we ensure your growth every step of the way. Join us to gain a competitive edge in your career."
            }
          />
        </Helmet>
        {/* Enquiry Form */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "100vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#00b7eb",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 70px)", // Adjust based on header height
                }}
              >
                <form ref={form} onSubmit={handleSubmitForm}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Full Name */}
                    <div>
                      <FaUser
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <FaEnvelope
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <FaPhone
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    {/* WhatsApp */}
                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <FaBuilding
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Service */}
                    <div>
                      <IoMdBuild
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Service</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    {/* Service Type */}
                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Type of Service</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Drone">Drone Solutions</option>
                        <option value="Robotics">Robotics Solutions</option>
                        <option value="IOT">Iot Solutions</option>
                        <option value="AI">Artificial Intelligence</option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        {/* <option value="Game">Game Development</option> */}
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">
                          AR & VR Apps
                        </option>
                        {/* <option value="Casino Api">Casino API</option> */}
                        {/* <option value="Devops Solutions">DevOps</option> */}
                        {/* <option value="It Support">IT Support</option> */}
                        <option value="Training Programs">Training</option>
                        {/* <option value="Digital Marketing">
                          Digital Marketing
                        </option> */}
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <FaGlobe
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={1}
                      placeholder="Tell us about your requirements..."
                      style={{
                        ...inputStyle,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div
                    className="mt-1 margin-top-home"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="submit"
                      style={{
                        background: "#00b7eb",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Banner */}
        <div className="position-relative min-vh-75 service-bg d-flex align-items-center justify-content-center bg-dark text-white">
          <div className="container position-relative" data-aos="fade-left">
            <div className="row align-items-center">
              <div className="col-lg-6 service-content">
                <nav aria-label="breadcrumb" className="mb-4">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item"
                      aria-current="page"
                    >
                      Services
                    </li>
                  </ol>
                </nav>
                <h3 className="display-5 fw-bold mb-3">Services</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Our Development Services */}
        <Container className="py-5" data-aos="fade-right">
          <h3 className="fw-bold text-center display-5 font-black mb-4">
            OUR DEVELOPMENT <span className="font-red">SERVICES</span>
          </h3>

          <Row className="align-items-center justify-content-center text-center text-md-start">
            <Col md={6} className="mb-3 mb-md-0">
              <p className="font-para mb-0">
                Our talented team is ready to guide your game from the concept
                to its release!
              </p>
            </Col>

            <Col md="auto" className="text-center text-md-start mt-3 mt-md-0">
              <button
                className="btn btn-red text-white fw-semibold px-4 py-2"
                onClick={() => setIsOpenEnquiry(true)} // 🔴 This line enables the popup
              >
                Get Started
              </button>
            </Col>
          </Row>
        </Container>

        {/* Services Card */}
        {/* <Container fluid className="mb-3 game-section" data-aos="fade-up">
        <div className="d-flex flex-wrap flex-md-nowrap justify-content-center gap-2">
          {services.map((service) => (
            <div
              key={service.id}
              className={`game-card ${active === service.id ? "active" : ""}`}
              onMouseEnter={() => setActive(service.id)}
              onMouseLeave={() => setActive(1)}
            >
              <div
                className="card-inner"
                style={{
                  backgroundImage:
                    active === service.id ? `url(${service.image})` : "none",
                }}
              >
                <div className="number-box">
                  <span className="number">
                    {String(service.id).padStart(2, "0")}
                  </span>
                </div>
                {active === service.id ? (
                  <div className="card-content">
                    <h5>{service.title}</h5>
                    <p>{service.desc}</p>
                  </div>
                ) : (
                  <div className="card-title">{service.title}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container> */}

        {/* <Container fluid className="mb-3 game-section" data-aos="fade-up">
        <div className="d-flex flex-wrap flex-md-nowrap justify-content-center gap-2">
          {services.map((service) => (
            <div
              key={service.id}
              className={`game-card ${active === service.id ? "active" : ""}`}
              onMouseEnter={() => setActive(service.id)}
              onMouseLeave={() => setActive(1)}
              onClick={() => setActive(service.id)} // Mobile support
            >
              <div
                className="card-inner"
                style={{
                  backgroundImage:
                    active === service.id ? `url(${service.image})` : "none",
                }}
              >
                <div className="number-box">
                  <span className="number">
                    {String(service.id).padStart(2, "0")}
                  </span>
                </div>
                {active === service.id ? (
                  <div className="card-content">
                    <h5>{service.title}</h5>
                    <p>{service.desc}</p>
                  </div>
                ) : (
                  <div className="card-title">{service.title}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container> */}

        <div className="min-vh-70 py-5" style={{ background: "#000000" }}>
          <div className="container">
            <Slider ref={sliderRef} {...settings}>
              {trainers.map((trainer, index) => (
                <div
                  key={trainer.id}
                  className={`trainer-card position-relative px-3 ${index % 2 === 0 ? "mt-n5" : "mt-5"
                    }`}
                  data-aos-delay={index * 150}
                >
                  <div className="trainer-card-inner position-relative">
                    <div
                      className="trainer-oval position-relative overflow-hidden rounded-pill"
                      style={{ width: "280px", height: "350px" }}
                    >
                      <div
                        className="gradient-overlay position-absolute top-0 start-0 end-0 bottom-0"
                        style={{
                          background: trainer.gradient,
                          opacity: 0.3,
                          mixBlendMode: "multiply",
                        }}
                      ></div>
                      <img
                        src={trainer.image}
                        alt={trainer.name}
                        className="w-100 h-100 object-fit-cover position-absolute top-0 start-0"
                        loading="lazy"
                      />
                      <div className="desc-overlay position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center">
                        <p className="desc-text text-white text-center px-3">
                          {trainer.desc}
                        </p>
                      </div>
                      <button className="btn btn-danger rounded-circle position-absolute top-3 end-3 p-2">
                        <svg
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          {/* Add your SVG path here if needed */}
                        </svg>
                      </button>
                    </div>
                    <div className="text-center mt-4">
                      <h3 className="text-white text-xl font-weight-bold mb-2 text-uppercase">
                        {trainer.name}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <style>{`
            .trainer-card {
              opacity: 0;
              transform: translateY(50px) scale(0.9);
              transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            }
            .trainer-card.aos-animate {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
            .trainer-card-inner:hover {
              transform: translateY(-10px);
            }
            .trainer-oval {
              transition: all 0.3s ease-in-out;
              border: 2px solid transparent;
            }
            .trainer-card-inner:hover .trainer-oval {
              box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);
              transform: scale(1.02);
              border: 2px solid #ff0000;
              box-shadow: 0 0 15px rgba(255, 0, 0, 0.5),
                0 0 30px rgba(255, 0, 0, 0.3);
            }
            .trainer-card-inner:hover .gradient-overlay {
              opacity: 0.5;
            }
            .desc-overlay {
              background: rgba(0, 0, 0, 0.7);
              opacity: 0;
              visibility: hidden;
              transition: all 0.3s ease-in-out;
              transform: translateY(20px);
            }
            .trainer-card-inner:hover .desc-overlay {
              opacity: 1;
              visibility: visible;
              transform: translateY(0);
            }
            .desc-text {
              font-size: 1.2rem;
              line-height: 1.4;
              font-weight: 400;
              margin: 0;
              transform: scale(0.95);
              transition: transform 0.3s ease-in-out;
            }
            .trainer-card-inner:hover .desc-text {
              transform: scale(1);
            }
            .slick-slide {
              padding: 0 15px;
            }
            .slick-dots li button:before {
              color: #fff;
              font-size: 12px;
            }
            .slick-dots li.slick-active button:before {
              color: #ff0000;
            }
            @media (max-width: 1024px) {
              .trainer-card {
                margin-top: 0 !important;
              }
              .trainer-card:nth-child(1) {
                animation-delay: 0s;
              }
              .trainer-card:nth-child(2) {
                animation-delay: 0.15s;
              }
              .trainer-card:nth-child(3) {
                animation-delay: 0.3s;
              }
              .trainer-card:nth-child(4) {
                animation-delay: 0.45s;
              }
              .trainer-card:nth-child(5) {
                animation-delay: 0.6s;
              }
              .trainer-card:nth-child(6) {
                animation-delay: 0.75s;
              }
            }
            @media (max-width: 768px) {
              .trainer-card {
                margin-top: 0 !important;
              }
              .trainer-card:nth-child(1) {
                animation-delay: 0s;
              }
              .trainer-card:nth-child(2) {
                animation-delay: 0.15s;
              }
              .trainer-card:nth-child(3) {
                animation-delay: 0.3s;
              }
              .trainer-card:nth-child(4) {
                animation-delay: 0.45s;
              }
              .trainer-card:nth-child(5) {
                animation-delay: 0.6s;
              }
              .trainer-card:nth-child(6) {
                animation-delay: 0.75s;
              }
            }
          `}</style>
        </div>

        {/* Swiper Slider */}
        <div
          className="slider-wrapper py-5 position-relative"
          data-aos="fade-up"
        >
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              nextEl: ".swiper-button-next-custom",
              prevEl: ".swiper-button-prev-custom",
            }}
            autoplay={{ delay: 4000 }}
            loop={true}
            className="game-slider"
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>
                <div
                  className="game-hero-section text-white d-flex align-items-center"
                  style={{ backgroundImage: `url(${slide.img})` }}
                >
                  <div className="clipped-corner-overlay"></div>
                  <Container fluid className="px-3 px-md-5">
                    <Row>
                      <Col md={6} className="text-section">
                        <h1 className="display-5 fw-bold">{slide.title}</h1>
                        <p className="text-white">{slide.text}</p>
                        <Button
                          variant="danger"
                          className="mt-4 px-4 py-2 fw-bold"
                        >
                          Read More
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="swiper-button-prev-custom">
            <FaCaretLeft />
          </div>
          <div className="swiper-button-next-custom">
            <FaCaretRight />
          </div>
        </div>

        {/* Additional Services */}
        {/* <div className="py-5 position-relative" data-aos="fade-down">
        <Container>
          <h3 className="text-uppercase display-5 red fw-bold mb-5">
            Additional Services
          </h3>
          <Row className="gy-4">
            {Additionalservice.map((service, i) => (
              <Col
                lg={3}
                md={6}
                sm={12}
                key={i}
                data-aos="fade-left"
                data-aos-duration="1000"
                data-aos-delay={i * 1000}
              >
                <div
                  ref={(el) => (cardRefs.current[i] = el)}
                  className={`service-card bg-white rounded-4 shadow p-4 h-100 ${
                    visibleCards.includes(i) ? "card-visible" : "card-hidden"
                  }`}
                >
                  <div className="mb-2 fs-4">
                    <img
                      src={service.icon}
                      alt="Icon"
                      className="img-fluid"
                      width="50"
                    />
                  </div>
                  <h2 className="fw-bold text-center red">{service.title}</h2>
                  <img
                    src={service.image}
                    alt="service"
                    className="img-fluid rounded mb-3"
                    style={{ height: "100px", width: "100%" }}
                  />
                  <p className="mb-2 font-para2">{service.desc}</p>
                  <ul className="list-unstyled fw-semibold mb-0">
                    {service.items.map((item, index) => (
                      <li key={index}>{`0${index + 1}. ${item}`}</li>
                    ))}
                  </ul>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div> */}

        {/* Our Creations */}
        <div className="card-grid" data-aos="fade-up">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <h3 className="text-uppercase mt-lg-5 md-lg-5 display-5  fw-bold mb-3">
              Our <span className="font-red">Creations</span>
            </h3>
            <p className="font-para text-center">
              Explore our proudest creations, each crafted with passion,
              precision, and cutting-edge technology.
            </p>
          </div>
          {games.map((game, index) => (
            <div
              key={index}
              className="card"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <img src={game.image} alt={game.title} className="card-img" />
              <div className="overlay"></div>
              <div className="card-content">
                <h2 className="">{game.title}</h2>
                <span className={`category ${game.categoryColor}`}>
                  {game.category}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Us */}
        <div
          className="background-red text-white py-5 px-3 position-relative overflow-hidden bg-dark"
          data-aos="fade-up"
        >
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.5), rgba(0,0,0,0.8))",
              zIndex: 1,
            }}
          ></div>
          <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="row align-items-center">
              <div className="col-md-6 text-center text-md-start mb-4 mb-md-0">
                <h2 className="fw-bold mb-2">HAVE QUESTIONS? CONTACT US NOW</h2>
                <h2 className="fw-bold">OUR TEAM IS HERE TO ASSIST YOU</h2>
              </div>
              <div className="col-md-6 d-flex justify-content-center justify-content-md-end">
                <div
                  className="input-group w-100"
                  style={{ maxWidth: "400px" }}
                >
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Your Email Address"
                  />
                  <button className="btn btn-danger text-white fw-bold subscribe-btn">
                    SUBSCRIBE NOW
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Service;
